
import { React } from 'react';

export function TitlePanel(props) {
  return (
    <div className="title-panel">
		<img src="./logo192.png" className="react-logo-40" alt="Intranet" />
		<div className="title-panel-left">
			<h1>{process.env.REACT_APP_TITLE}</h1>
			<p>({process.env.NODE_ENV} / {process.env.REACT_APP_API_BASE})</p>
		</div>
		<p className="title-panel-right">{props.username}</p>
		{props.username !== undefined && <button onClick={props.logout}>Logout</button>}
    </div>
  );
}
